<template>
  
    <content-header
        icona="fas fa-industry"
        titolo="Anagrafica Clienti"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">

            <!-- *** GRIGLIA ANAGRAFICA *** -->
            <div class="card" v-if="mostraGrigliaAnagrafica">
                <div class="card-body">

                    <button type="button" class="btn btn-dark" @click="GetListAnagrafica()">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;
                    <button type="button" class="btn btn-success" @click="AttivaEditAnagrafica">
                        <i class="fas fa-plus"></i>&nbsp;Nuova anagrafica
                    </button>&nbsp;
                    <button type="button" class="btn btn-secondary" @click="EsportaListaAnagrafica">
                        <i class="fas fa-file-excel"></i>&nbsp;Esporta elenco
                    </button>
                    <br /><br />

                    <div class="d-flex justify-content-start">
                        <div class="form-group mx-2 " style="width:350px">
                            <label>Ricerca testuale</label>
                            <input type="text" class="form-control form-control-sm" placeholder="cerca per ..." v-model="reqGrigliaAnagrafica.Testuale" @keyup.enter="GetListVSAnagrafica" />
                        </div>
                        
                        <div class="from-group mx-2">
                            
                            <a class="btn btn-sm btn-dark" @click="AzzeraFiltri" style="margin-top:30px;">
                            <i class="fas fa-times"></i>&nbsp;Azzera
                            </a>&nbsp;
                            <a class="btn btn-sm btn-info" @click="GetListVSAnagrafica" style="margin-top:30px;" >
                            <i class="fas fa-search"></i>&nbsp;Cerca
                            </a>
                        </div>
                    </div>  
                    <div class="d-flex justify-content-start">
                        <!-- <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" v-model="reqGrigliaAnagrafica.Clienti" @change="GetListVSAnagrafica">
                            <label class="form-check-label">Clienti</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" v-model="reqGrigliaAnagrafica.Fornitori" @change="GetListVSAnagrafica">
                            <label class="form-check-label">Fornitori</label>
                        </div> -->
                        <!-- <div class="form-check">
                            <input class="form-check-input" type="checkbox">
                            <label class="form-check-label">
                                Mostra fornitori
                            </label>
                        </div>
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="reqGrigliaDocumenti.Obsoleti" @change="GetListDocumenti"  />&nbsp;Mostra documenti OBSOLETI
                            </label>
                        </div> -->

                    </div>
                    
                    
                    <br/>
                    <griglia-facile
                        :colonne-header="g_colonneHeader"
                        :colonne="g_colonne"
                        :colonneNoOrder="g_colonneNoOrder"
                        :colonneAlign="g_colonneAlign"
                        :comandi="g_comandi"
                        :mostraPager="true"
                        classi-table="table-sm table-hover table-custom"
                        :dati="dtVSAnagrafica"
                        :queryLength="g_queryLength"
                        :currentPage="g_currentPage"
                        
                        @Seleziona="SelectAnagra"
                        @Cancella="DelElemAnagrafica"
                        @Ordina="OrdinaGriglia"
                        
                        @CambiaElementi="CambiaElementi"
                        @Precedente="PaginaPrecendente"
                        @Successiva="PaginaSuccessiva"
                        @CambiaPagina="CambiaPagina"

                        

                        fontawesome="standard"

                        ></griglia-facile>

                </div>
            </div>

            <!-- *** EDIT ANAGRAFICA CLIENTE *** -->
            <div class="card" v-if="mostraEditAnagrafica">
            <div class="card-header">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaAnagrafica(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaAnagrafica(false)">Salva e Chiudi</button>
            </div>
            <div class="card-body">
                

                <form autocomplete="off">

                <messaggio-standard 
                    :mostraMessaggio="mostraMessaggio"
                    :alertClass="alertClass"
                    :alertIcon="alertIcon"
                    :alertIconSpin="alertIconSpin"
                    :alertMessaggio="alertMessaggio"
                    fontawesome="standard"
                    ></messaggio-standard>
                    
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-info text-primary"></i>&nbsp;Dati generali
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Ragione Sociale</label>
                    <input type="text" class="form-control" v-model="oAnagrafica.ana_ragioneSociale">
                </div>
                

                <div class="row">
                    <div class="col-md-4 mb-3">
                        <label class="form-label">Indirizzo</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_indirizzo">
                    </div>
                    <div class="col-md-4 mb-3">
                        <label class="form-label">Città</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_citta">
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="form-label">Provincia</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_prov">
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="form-label">CAP</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_cap">
                    </div>
                    
                </div>

                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-envelope text-primary"></i>&nbsp;Informazioni di contatto
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4 mb-3">
                        <label class="form-label">Telefono</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_tel">
                    </div>
                    <div class="col-md-4 mb-3">
                        <label class="form-label">Cellulare</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_cell">
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 mb-3">
                        <label class="form-label">Email</label>
                        <input type="email" class="form-control" v-model="oAnagrafica.ana_email">
                    </div>
                    <div class="col-md-3 mb-3">
                        <label class="form-label">PEC</label>
                        <input type="email" class="form-control" v-model="oAnagrafica.ana_pec">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Sito Web</label>
                        <input type="url" class="form-control" v-model="oAnagrafica.ana_sito">
                    </div>

                </div>

                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-gavel text-success"></i>&nbsp;Dati fiscali
                    </div>
                </div>

                <div class="row">   
                    <div class="col-md-4 mb-3">
                        <label class="form-label">Codice Fiscale</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_cf">
                    </div>
                    <div class="col-md-4 mb-3">
                        <label class="form-label">Partita IVA</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_piva">
                    </div>
                    <div class="col-md-4 mb-3">
                        <label class="form-label">Codice SDI</label>
                        <input type="text" class="form-control" v-model="oAnagrafica.ana_codSdi">
                    </div>
                </div>


                <template  v-if="oAnagrafica.ana_id > 0">
                    <div class="row rigaSezioneForm">
                        <div class="col-md">
                            <i class="fas fa-lock text-warning"></i>&nbsp;Accesso riservato cliente
                        </div>
                    </div>
                    <div class="row">   
                        <div class="col-md-3 mb-3">
                            <label class="form-label">Username</label>
                            <input type="text" class="form-control" v-model="oAnagrafica.ana_username">
                        </div>
                        <div class="col-md-3 mb-3">
                            <label class="form-label">Password</label>
                            <input type="password" class="form-control" v-model="oAnagrafica.ana_password" autocomplete="new-password">
                            <small>Digitare una password per cambiarla</small>
                        </div>
                    </div>
                </template>
                
                
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-cog text-secondary"></i>&nbsp;Varie
                    </div>
                </div>
                
                <div class="mb-3">
                    <label class="form-label">Note</label>
                    <textarea class="form-control" v-model="oAnagrafica.ana_note"></textarea>
                </div>

                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-users text-bucher"></i>&nbsp;Personale
                    </div>
                </div>

                <template v-if="oAnagrafica.ana_id > 0">

                    <button type="button" class="btn btn-dark" @click="GetListPersonale(oAnagrafica.ana_id)">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;
                    <button type="button" class="btn btn-success" @click="EditPersonale">
                        <i class="fas fa-plus"></i>&nbsp;Aggiungi personale
                    </button>&nbsp;
                    <button type="button" class="btn btn-secondary" @click="EsportaListaPersonale">
                        <i class="fas fa-file-excel"></i>&nbsp;Esporta elenco
                    </button>
                    <br />

                    <!-- *** EDIT PERSONALE ***-->
                    <a name="editPersonale"></a>
                    <div class="bg-edit mt-2 mb-2 p-2 rounded " v-if="mostraEditPersonale">

                        <div class="row rigaSezioneForm m-2">
                            <div class="col-md">
                                <i class="fas fa-edit text-primary"></i>&nbsp;Modifica/Immetti
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Cognome</label>
                                <input type="text" class="form-control" v-model="oPersonale.per_cognome" placeholder="Inserisci Cognome">
                            </div>
                            <div class="mb-3 col-md-6">
                                <label class="form-label">Nome</label>
                                <input type="text" class="form-control" v-model="oPersonale.per_nome" placeholder="Inserisci Nome">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 mb-3">
                                <label class="form-label">Codice Fiscale</label>
                                <input type="text" class="form-control" v-model="oPersonale.per_cf" placeholder="Inserisci Codice Fiscale">
                            </div>
                            <div class="col-md-3 mb-3">
                                <label class="form-label">Email</label>
                                <input type="email" class="form-control" v-model="oPersonale.per_email" placeholder="Inserisci Email" :disabled="oPersonale.per_nomail ? true : null">
                            </div>
                            <div class="col-md-6 mb-3">
                                <div class="d-flex form-group pt-5">
                                    <input class="form-check-input" type="checkbox" v-model="oPersonale.per_nomail">
                                    <label class="form-check-label ms-2">
                                        La persona NON HA una email valida (non potranno essere effettuati quiz).
                                    </label>
                                </div>
                                
                            </div>
                        </div>


                        <messaggio-standard 
                            :mostraMessaggio="mostraMessaggioPers"
                            :alertClass="alertClassPers"
                            :alertIcon="alertIconPers"
                            :alertIconSpin="alertIconSpinPers"
                            :alertMessaggio="alertMessaggioPers"
                            fontawesome="standard"
                            ></messaggio-standard>

                        
                        



                        <div class="d-flex">
                            <div class="pe-2"><button type="button" class="btn btn-secondary btn-sm" @click="mostraEditPersonale=false; ClearMessaggioPers()">Annulla</button></div>
                            <div class="pe-2"><button type="button" class="btn btn-primary btn-sm" @click="SalvaPersonale">Salva</button></div>
                        </div>
                        

                    </div>
                    


                    <!-- *** ELENCO PERSONALE ***-->
                    <table class="table table-custom">
                        <thead>
                            <tr>
                                <th>Cognome</th>
                                <th>Nome</th>
                                <th>Cod. Fisc.</th>
                                <th>Email</th>
                                <th><i class="fas fa-bars"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="p, i in dtPersonale" :key="i" @dblclick="EditPersonale(p.per_id)">
                                <td><span :class="{'text-cancellato': p.per_eliminato}">{{ p.per_cognome }}</span></td>
                                <td><span :class="{'text-cancellato': p.per_eliminato}">{{ p.per_nome }}</span></td>
                                <td><span :class="{'text-cancellato': p.per_eliminato}">{{ p.per_cf }}</span></td>
                                <td>{{ p.per_email }}</td>
                                <td>
                                    <a href="#j" class="btn btn-sm btn-outline-primary me-1" @click="EditPersonale(p.per_id)"><i class="fas fa-edit" title="Edit"></i></a>
                                    <a href="#j" class="btn btn-sm btn-outline-danger me-1" @click="DelElemPersonale(p.per_id, true)" v-if="!p.per_eliminato"><i class="fas fa-trash" title="Cancella"></i></a>
                                    <a href="#j" class="btn btn-sm btn-outline-warning me-1" @click="DelElemPersonale(p.per_id, false)" v-else><i class="fas fa-undo" title="Ripristina"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </template>
                <template v-else>
                    <em>La sezione è visibile solo durante la modifica di un'anagrafica esistente.</em>
                </template>

                
                              
                

                </form>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaAnagrafica(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaAnagrafica(false)">Salva e Chiudi</button>
            </div>
            </div>

        </div>
    </div>

    <iframe id="iFrameDn" name="iFrameDn" src="about:blank" style="display:none"></iframe> 
        
    
</template>

<script>
import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import MessaggioStandard from '@/components/MessaggioStandard.vue';
import ContentHeader from '@/components/layout/ContentHeader.vue';

export default {
    name: 'AnagraficaView',
    components: {
        ContentHeader, GrigliaFacile, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtVSAnagrafica: [],
            dtPersonale: [],

            //Impostazioni griglia DOCUMENTI
            g_colonne: ['ana_id', 'ana_ragioneSociale', 'ana_citta','ana_cell', 'ana_email', 'ana_username', 'ncollaboratori'],
            g_colonneHeader: ['Id', 'Denominazione', 'Città', 'Cell.', 'Email', 'UID Accesso', '# collab.'],
            g_colonneNoOrder: ['ncollaboratori'], 
            g_colonneAlign: [],
            g_comandi: 
            [
                {titolo:'Cancella', icona:'fa-trash', iconaStile: 'btn btn-xs btn-outline-danger', emetti: 'Cancella'},
            ],
            g_queryLength: 0, //lunghezza della query (che NON è la lunghezza del dataset passato)
            g_currentPage: 1, //pagina corrente

            //Oggetto richiesta griglia
            reqGrigliaAnagrafica: {
                ele_pag: 10,
                start: 0,
                orderColumn: "ana_ragioneSociale",
                orderDir:"ASC",
                token: this.$store.state.UserInfo.token,
                //Campi custom
                Testuale: "",
                Clienti: true,
                Fornitori: false,
                
            },

            oAnagrafica: {
                ana_id: -1,
                ana_cognome: "",
                ana_nome: "",
                ana_ragioneSociale: "",
                ana_indirizzo: "",
                ana_citta: "",
                ana_cap: "",
                ana_tel: "",
                ana_cell: "",
                ana_email: "",
                ana_pec: "",
                ana_sito: "",
                ana_cf: "",
                ana_piva: "",
                ana_codSdi: "",
                ana_note: "",
                ana_prov: "",
                ana_username: "",
                ana_password: "",
                ana_lastLogin: new Date(1900,1,1),

                token: "",
            },

            oPersonale: {
                per_id: -1,
                per_idAna: -1,
                per_cognome: "",
                per_nome: "",
                per_cf: "",
                per_email: "",
                per_lastLogin: new Date(1900,1,1),
                per_nomail: false,

                token: "",
            },

            mostraGrigliaAnagrafica: true,
            mostraEditAnagrafica: false,
            mostraEditPersonale: false,

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false,

            mostraMessaggioPers: false,
            alertMessaggioPers: "",
            alertClassPers: "",     
            alertIconPers: "",
            alertIconSpinPers: false


        }
    },
    methods: {
        // GESTIONE PANNELLI E PULIZIA INPUT
        AttivaGriglia() {
            this.mostraEditAnagrafica = false;
            this.mostraGrigliaAnagrafica = true;

            this.GetListAnagrafica();
        },
        AzzeraFiltri() {
            this.reqGrigliaAnagrafica.Testuale = "";
            this.GetListAnagrafica();
        },
        AttivaEditAnagrafica() {
            this.mostraEditAnagrafica = true;
            this.mostraGrigliaAnagrafica = false;

            
            this.ClearMessaggio();
            this.ClearAnagrafica();
            this.dtPersonale = [];

        },
        ClearAnagrafica() {
            this.oAnagrafica = {
                ana_id: -1,
                ana_cognome: "",
                ana_nome: "",
                ana_ragioneSociale: "",
                ana_indirizzo: "",
                ana_citta: "",
                ana_cap: "",
                ana_tel: "",
                ana_cell: "",
                ana_email: "",
                ana_pec: "",
                ana_sito: "",
                ana_cf: "",
                ana_piva: "",
                ana_codSdi: "",
                ana_note: "",
                ana_prov: "",
                ana_username: "",
                ana_password: "",
                ana_lastLogin: new Date(1900,1,1), 
                
                token: "",
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
        ClearMessaggioPers() {
            this.mostraMessaggioPers = false;
            this.alertMessaggioPers =  "";
            this.alertClassPers = "";
            this.alertIconPers = "";
            this.alertIconSpinPers = false;
        },
        ClearPersonale() {
            this.oPersonale = {
                per_id: -1,
                per_idAna: -1,
                per_cognome: "",
                per_nome: "",
                per_cf: "",
                per_email: "",
                per_lastLogin: new Date(1900,1,1),
                per_nomail: false,

                token: "",
            }
        },
       // *** OPERAZIONI DI BASE SU Anagrafica
        GetListAnagrafica() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento griglia in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/GetListAnagraficaClienti" , {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.reqGrigliaAnagrafica)
            }).then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Griglia caricata.'], 'alert alert-success', 'fa-check', false, 2000]});
                
                        // for(let i = 0; i<obj.moreJsonData.length; i++){
                        // }

                        this.dtVSAnagrafica = obj.moreJsonData;
                        this.g_queryLength = parseInt(obj.dati[0], 10);
                        if(this.reqGrigliaAnagrafica.Testuale != "") this.EvidenzaRicerca();
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errore caricamento griglia.'], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                });
        },
        GetElemAnagrafica(idelem) {
            //Carica elemento singolo
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/GetElemAnagraficaClienti?token=" + this.$store.state.UserInfo.token + "&id=" + idelem)
            .then(response => response.json())
            .then(obj => {

                this.oAnagrafica = obj;

                this.mostraGrigliaAnagrafica=false;
                this.mostraEditAnagrafica= true;

                this.$store.commit('Messaggio', {parms: [true, ['Anagrafica caricata.'], 'alert alert-success', 'fa-check', false, 2000]});

            });
        },
        //Esporta su Excel
        EsportaListaAnagrafica() {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&orderColumn=" + this.reqGrigliaAnagrafica.orderColumn + "&orderDir=" + this.reqGrigliaAnagrafica.orderDir +
                    "&Testuale=" + this.reqGrigliaAnagrafica.Testuale;
            let url =this.cfg.apisrv + "/api/AnagraficaClienti/EsportaListaAnagrafica" + qy;
            let iFrameDn = document.getElementById("iFrameDn");
            iFrameDn.src = url;
          
        },
        //modifica anagrafica 
        SelectAnagra(o)  {
            //this.dtPersonale = [];
            this.ClearPersonale();
            this.GetElemAnagrafica(o.ana_id);
            this.GetListPersonale(o.ana_id);
        },

        SalvaAnagrafica(reload) {
            let oSubmit = [];
            oSubmit = this.oAnagrafica;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            this.ClearMessaggio();
            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/SalvaAnagraficaClienti", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        if(reload)  {
                            //this.oUtente = obj.moreJsonData;
                            this.GetElemAnagrafica(obj.dati[0]);
                        }
                        else {
                            //Fa redirect
                            this.AttivaGriglia();
                        }
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

        },

        DelElemAnagrafica(e) {
        //Cancella elemento singolo
        if(confirm("Cancellare l'elemento?")) {
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/DelElemAnagraficaClienti?token=" + this.$store.state.UserInfo.token + "&id=" + e.ana_id)
            .then(response => response.json())
            .then(obj => {
                if(obj.status == "OK") {
                    this.$store.commit('Messaggio', {parms: [true, ['Eliminato'], 'alert alert-success', 'fa-check', false, 2000]});
                    this.GetListAnagrafica(); 
                } else {
                    this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                }
                
            });
        }

      },

    // *** OPERAZIONI DI BASE SU Personale
    GetListPersonale(idAna) {
        //Carica lista elementi
        fetch(this.cfg.apisrv + "/api/Personale/GetListPersonale?token=" + this.$store.state.UserInfo.token + "&idAna=" + idAna)
            .then(response => response.json())
            .then(obj => {
                this.dtPersonale = obj;
            });
    },
    GetElemPersonale(idelem) {
      //Carica elemento singolo
        fetch(this.cfg.apisrv + "/api/Personale/GetElemPersonale?token=" + this.$store.state.UserInfo.token + "&idPer=" + idelem)
        .then(response => response.json())
        .then(obj => {
            //Dummy format data
            //obj.pst_data = snFunctions.dateFormat(obj.pst_data, "yyyy-MM-dd"); //formatta la data per il campo input
            this.oPersonale = obj;
            this.oPersonale.per_idAna = this.oAnagrafica.ana_id;

            //this.GetListPersonale();
        });
      },
    EditPersonale(id) {
        window.location.href = "#editPersonale";
        this.mostraEditPersonale = true;
        this.ClearPersonale();
        if (id > 0) this.GetElemPersonale(id);
    },
    DelElemPersonale(idelem, undelete) {
        //Cancella elemento singolo
        if(confirm("Cancellare l'elemento?")) {
            fetch(this.cfg.apisrv + "/api/Personale/DelElemPersonale?token=" + this.$store.state.UserInfo.token + "&idPer=" + idelem + "&undelete=" + undelete)
            .then(response => response.json())
            .then(obj => {
                this.GetListPersonale(this.oAnagrafica.ana_id);
            });
        }

    },
    SalvaPersonale() {
        let oSubmit = [];
        oSubmit = this.oPersonale;
        oSubmit.per_idAna = this.oAnagrafica.ana_id;
        oSubmit.token = this.$store.state.UserInfo.token;

        this.ClearMessaggioPers();
        fetch(this.cfg.apisrv + "/api/Personale/SalvaPersonale", {
            "method": "POST",
            "headers": {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "body": JSON.stringify(oSubmit)
        }).then(response => response.json())
            .then(obj => {
                if (obj.status == "OK") {
                    this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                    this.mostraEditPersonale = false;
                    this.ClearPersonale();
                    this.GetListPersonale(this.oAnagrafica.ana_id);

                }
                else {
                    this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});
                
                    this.mostraMessaggioPers = true;
                    this.alertMessaggioPers = obj.dati;
                    this.alertClassPers = "alert alert-warning";
                    this.alertIconPers = "fa-xmark"
                    this.alertIconSpinPers = false
                }
            });

    },

    

      
    

    //PAGINAZIONE GRIGLIA
    CambiaElementi(nrElem) {
        this.reqGrigliaAnagrafica.ele_pag = nrElem;
        this.GetListAnagrafica();
    },
    PaginaPrecendente() {
        this.reqGrigliaAnagrafica.start = this.reqGrigliaAnagrafica.start - parseInt(this.reqGrigliaAnagrafica.ele_pag, 10);
        this.g_currentPage--;
        this.GetListAnagrafica();  
    
    },
    PaginaSuccessiva() {
        this.reqGrigliaAnagrafica.start = this.reqGrigliaAnagrafica.start + parseInt(this.reqGrigliaAnagrafica.ele_pag, 10);
        this.g_currentPage++;
        this.GetListAnagrafica();
    
    },
    CambiaPagina(pag) {
        this.reqGrigliaAnagrafica.start = (parseInt(this.reqGrigliaAnagrafica.ele_pag, 10) * pag) - parseInt(this.reqGrigliaAnagrafica.ele_pag, 10);
        this.g_currentPage = pag;
        this.GetListAnagrafica();
    },

    // ORDINA LA GRIGLIA
    OrdinaGriglia(i) {
        if(this.reqGrigliaAnagrafica.orderColumn == this.g_colonne[i]) {
            //Stessa colonna
            if(this.reqGrigliaAnagrafica.orderDir == 'DESC') {this.reqGrigliaAnagrafica.orderDir = 'ASC';}
            else {this.reqGrigliaAnagrafica.orderDir = 'DESC';}
        }
        else {
            //altra colonna
            this.reqGrigliaAnagrafica.orderColumn = this.g_colonne[i];
            this.reqGrigliaAnagrafica.orderDir = 'DESC';
            
        }
        
        this.GetListAnagrafica();

    },

   

    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListAnagrafica();
        

    }
}
</script>